package org.vreo.devicehub.features.core.data.protocolBuffer.mappers

import org.vreo.devicehub.features.core.domain.device.singleShootAutoFocus.SingleShotAutoFocusConfig
import vreo.volt.protocol.SingleShotAutofocus

/**
 * Extension function to map a [SingleShotAutoFocusConfig] to a [SingleShotAutofocus]. Allows to map local data class
 */
fun SingleShotAutoFocusConfig.toSingleShotAutoFocusProto(): SingleShotAutofocus {
    return SingleShotAutofocus(
        config = this.config
    )
}

/**
 * Extension function to map a [SingleShotAutofocus] to a [SingleShotAutoFocusConfig]. Allows to map protocol buffer
 */
fun SingleShotAutofocus.toSingleShotAutoFocusConfig(): SingleShotAutoFocusConfig {
    return SingleShotAutoFocusConfig(
        config = this.config
    )
}